// extracted by mini-css-extract-plugin
export var createdDate = "_nv-1";
export var divider = "_nv-2";
export var headerDivider = "_nv-3";
export var messagesCard = "_nv-0";
export var messagesContainer = "_nv-7";
export var messagesContainerWrapper = "_nv-4";
export var pointerCapturingButtonBoxes = "_nv-a";
export var showLeftPanelButton = "_nv-9";
export var showMoreButton = "_nv-c";
export var showMoreButtonContainer = "_nv-b";
export var summaryTitle = "_nv-6";
export var systemMessageCardWrapper = "_nv-d";
export var topButtons = "_nv-8";
export var withPadding = "_nv-5";